/* eslint-disable @typescript-eslint/no-explicit-any */
import Big from "big.js";
import React, { useEffect, useState } from "react";
import NumberFormat, {
  NumberFormatProps,
  SourceInfo,
} from "react-number-format";
import { useLanguage } from "../../../store";

interface PercentageInputPropsType {
  $hideCurrencySymbol?: boolean;
  // All other props
  [x: string]: any;
}

export const PercentageInput: React.FC<PercentageInputPropsType> = ({
  onValueChange,
  ...props
}: NumberFormatProps) => {
  PercentageInput.defaultProps = {
    $hideCurrencySymbol: false,
  };

  const [language] = useLanguage();

  const [value, setValue] = useState<string | number>(
    Big(props.value || 0)
      .times(100)
      .toNumber() || ""
  );

  const handleChange = (v: any, sourceInfo: SourceInfo): void => {
    // Sincronizes inside and outside states
    setValue(Big(v.value).times(100).toNumber());

    if (onValueChange) {
      onValueChange(
        { ...v, floatValue: Big(v.floatValue).div(100).toNumber() },
        sourceInfo
      );
    }
  };

  const percentageFormatter = (formattedValue: any): string => {
    const br = { style: "currency", currency: "BRL" };

    return new Intl.NumberFormat(language || "pt-BR", br)
      .formatToParts(
        Big(formattedValue || 0)
          .div(100)
          .toNumber()
      )
      .map((parameter) =>
        parameter.type !== "literal" && parameter.type !== "currency"
          ? parameter.value
          : ""
      )
      .join("")
      .concat(" %");
  };

  const keyDown = (e: any): void => {
    // Keeps the cursor position on erase if the value is === 0
    if (e.code === "Backspace" && !value) {
      e.preventDefault();
    }
    // Sets the value to 0 and prevents the default so curor remains in "cents" area
    if (e.code === "Backspace" && value < 1000) {
      e.preventDefault();
      setValue(0);
    }
  };

  // Sincronizes inside and outside states
  useEffect(
    () =>
      setValue(
        Big(props.value || 0)
          .times(100)
          .toNumber()
      ),
    [props.value]
  );

  // Debug Tool
  //
  // const logOnFocus = (): void => {
  //   console.log(">>> Prop recebida:", props.value);
  // };

  const handleClick = (e: any): void => {
    try {
      if (value === 0) {
        const valueSize = String(e.target.value).length;
        e.target.selectionEnd = valueSize;
        e.target.selectionStart = valueSize;
      }
    } catch {
      // ignore error
    }
  };

  return (
    <NumberFormat
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      value={Big(Number(value)).div(100).toNumber()}
      format={percentageFormatter}
      onValueChange={handleChange}
      allowEmptyFormatting
      onKeyDown={keyDown}
      // onFocus={logOnFocus}
      onClick={handleClick}
    />
  );
};

export default PercentageInput;
